export default {
  state: {
    config: null,
  },
  mutations: {
    setConfig: (state, config) => {
      state.config = config;
    },
  },
  actions: {
    close({ commit }) {
      commit('setConfig', null);
    },
    message({ commit }, message) {
      // console.debug(`modal: ${message}`);
      const config = {
        header: { class: 'has-background-success' },
        title: { content: 'Message' },
        body: { content: message },
        closeButton: { emits: [{ event: 'close-modal' }] },
        leftButton: { emits: [{ event: 'close-modal' }], class: 'is-primary', content: 'Close' },
      };
      commit('setConfig', config);
    },
    error({ commit }, error) {
      let message = error;
      if (error.message) {
        message = error.message;
      }
      console.error(`modal: ${message}`);
      const config = {
        header: { class: 'has-background-danger' },
        title: { content: 'Error' },
        body: { content: message },
        closeButton: { emits: [{ event: 'close-modal' }] },
        leftButton: { emits: [{ event: 'close-modal' }], class: 'is-primary', content: 'Close' },
      };
      commit('setConfig', config);
    },
  },
  modules: {
  },
  namespaced: true,
};
